import Layout from '../components/Layout/Layout.js';
import Login from '../container/Login/Login.js';

import Auth from '../components/Auth/Auth';
import Qoute from '../pages/qoute/index.jsx';
import Setting from '../pages/setting/index.jsx';
import Account from '../pages/account/index.jsx';
import Home from '../pages/home/index.jsx';
import Manage from '../pages/manage/index.jsx';
import Order from '../pages/order/index.jsx';



let routes = [
  {
    path: '/',
    element: 
      <Auth>
        <Layout/>
      </Auth>,
    children: [
      { path: '/layout/home', element: <Home/>},
      { path: '/layout/order', element: <Order/>},
      { path: '/layout/qoute', element: <Qoute/>},
      { path: '/layout/setting', element: <Setting/>},
      { path: '/layout/account', element: <Account/>},
      { path: '/layout/manage', element: <Manage/>}
    ]
  },
  {
    path: '/login',
    element: <Login/>
  }
];


export default routes;